import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import OrcamentosPage from './pages/OrcamentosPage';
import NovoOrcamentoPage from './pages/NovoOrcamentoPage';
import OrcamentoDetailPage from './pages/OrcamentoDetailPage';
import ClientesPage from './pages/ClientesPage';
import ProdutosPage from './pages/ProdutosPage';
import UsuariosPage from './pages/UsuariosPage';
import TipoPersianasPage from './pages/TipoPersianasPage';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Carregando...</div>;
  return user ? <>{children}</> : <Navigate to="/login" replace />;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  return user?.role === 'ADMIN' ? <>{children}</> : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="orcamentos" element={<OrcamentosPage />} />
            <Route path="orcamentos/novo" element={<NovoOrcamentoPage />} />
            <Route path="orcamentos/:id" element={<OrcamentoDetailPage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="produtos" element={<AdminRoute><ProdutosPage /></AdminRoute>} />
            <Route path="tipos-persiana" element={<AdminRoute><TipoPersianasPage /></AdminRoute>} />
            <Route path="usuarios" element={<AdminRoute><UsuariosPage /></AdminRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
